// eslint-disable-next-line import/no-webpack-loader-syntax
import 'file?name=[name].[ext]!../index.html'
import React from 'react'
import thunk from 'redux-thunk'
import { render } from 'react-dom'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from '@redux-devtools/extension'
import Routes from './routes'
import reducers, { CURRENT_STATE_VERSION } from './reducers'
import { loadState, saveState } from './localStorage'
import cloneDeep from 'lodash/cloneDeep'
import unset from 'lodash/unset'
import debounce from 'lodash/debounce'

function versionedState () {
  const state = loadState()
  if (state && state.version === CURRENT_STATE_VERSION) {
    return state.data
  } else if (state && state.data && state.data.currentUser) {
    return {currentUser: state.data.currentUser}
  } else {
    return undefined
  }
}

function persistVersionedState (data) {
  saveState({
    version: CURRENT_STATE_VERSION,
    data
  })
}

function stateToSync (state) {
  let cloneState = cloneDeep(state)
  const excludes = ['form.login']
  excludes.forEach(exclude => unset(cloneState, exclude))
  return cloneState
}

const store = createStore(
  reducers,
  versionedState(),
  composeWithDevTools(applyMiddleware(thunk))
)

store.subscribe(debounce(() => {
  persistVersionedState(stateToSync(store.getState()))
}), 250, { 'maxWait': 1000 })

render(
  <Provider store={store}>
    <Routes />
  </Provider>, document.getElementById('app')
)



// WEBPACK FOOTER //
// ./src/index.js